var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 170,
    viewBox: "0 0 65 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1233_1588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0254 169.949L65 169.949L54.5127 159.461L44.0254 169.949Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0254 134.41L65 134.41L54.5127 123.923L44.0254 134.41Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0254 98.8564L65 98.8564L54.5127 88.3691L44.0254 98.8564Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0254 63.3178L65 63.3178L54.5127 52.8305L44.0254 63.3178Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0254 27.7791L65 27.7791L54.5127 17.2767L44.0254 27.7791Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000263214 152.672L20.9749 152.672L10.4876 142.185L0.000263214 152.672Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90735e-05 117.118L20.9746 117.118L10.4873 106.631L1.90735e-05 117.118Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90735e-05 81.5795L20.9746 81.5795L10.4873 71.0922L1.90735e-05 81.5795Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90735e-05 46.041L20.9746 46.041L10.4873 35.5537L1.90735e-05 46.041Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.90735e-05 10.4872L20.9746 10.4872L10.4873 -7.82381e-05L1.90735e-05 10.4872Z",
    fill: "#1877F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1233_1588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 169.949,
    fill: "white",
    transform: "translate(65 169.949) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects);
export default __webpack_public_path__ + "static/media/OBJECTS.5e81cc0df504ef4bcfa7497875c3ce06.svg";
export { ForwardRef as ReactComponent };